import React from 'react';
import './wishes.css';

function Wishes() {
  return (
    <section className="gift-and-ceremony">
      <img src="/images/couple-icon.svg" alt="" className="gift-icon" aria-hidden="true"/>

      <p className="gift-text">
        Самое важное для нас - отпраздновать этот день с вами.
        Но если вы захотите сделать подарок, будем благодарны за финансовую поддержку.
      </p>

      <img src="/images/heart.svg" alt="" className="heart" aria-hidden="true" loading="lazy"/>

      <p className="ceremony-text">
        Во время церемонии просим
        прожить этот момент глазами, а не камерами.
        Профессиональный фотограф и видеограф всё снимут,
        и мы обязательно поделимся с вами фото и видео.
      </p>
    </section>
  );
}

export default Wishes;